
import useAxiosPrivate from "./useAxiosPrivate";
import { useDispatch } from "react-redux";


const useAssignPincode = () => {
  const Axios = useAxiosPrivate();
  const dispatch = useDispatch();

  const setAssignPincode = async (param) => {
    try {
      const response = await Axios.post("shapefile_assign", param);
      const data = response.data;
      console.log(data, "asignSe")
      return data;  
    } catch (error) {
      console.error("Error fetching admin map data:", error);
      throw error;  
    }
  };
  return setAssignPincode;
};

export default useAssignPincode;


